import { environment } from '@infra-env/environment';

/**
 * Shared polling interval for auto-refreshing Backoffice listings (POLAR-700).
 * Sourced from environment config so it can be tuned per environment without a code change.
 */
export const AUTO_REFRESH_INTERVAL_MS = environment.autoRefreshIntervalMs;
